import React from 'react';
import {observer} from "mobx-react";
import {IFlightDesignatorViewModel} from "../../../services/booking/models/designator/flight-designator-view-model.interface";
import styled from "styled-components";
import {useServices} from "../../../hooks/use-services.hook";
import {AirlineLogoSmallMulticolorIcon} from "../../../assets/svg/airline-logo-small-multicolor.icon";
import {DesignatorPlaneIconComponent} from "../common/components/designator-plane-icon.component";

const JourneyDesignatorBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  
  font-size: ${props => props.theme.fontSize.h5};
  font-weight: ${props => props.theme.fontWeight.bold};
`

const AirlineLogoBox = styled.div`
  padding-right: ${props => props.theme.spacing.spacing8};
`

interface JourneyDesignatorComponentProps {
    designator: IFlightDesignatorViewModel;
    className?: string
}

export const JourneyDesignatorComponent: React.FC<JourneyDesignatorComponentProps> = observer((props) => {
    const designator = props.designator;
    const services = useServices();
    return (
        <JourneyDesignatorBox className={props.className}>
            <AirlineLogoBox>
                <AirlineLogoSmallMulticolorIcon color={services.theme.currentTheme.colors.tertiary} size={1.6} />
            </AirlineLogoBox>

            {designator.origin.stationName} ({designator.origin.stationCode})

            <DesignatorPlaneIconComponent/>

            {designator.destination.stationName} ({designator.destination.stationCode})

        </JourneyDesignatorBox>

    );
});
